//1. Vue.js basic package.
import Vue from 'vue';
import App from './App.vue';
//2. Vue.js third-party packages.
import store from './store';
import router from './router';
import axios from 'axios';
//3. Vue.js plugins.
import vuetify from './plugins/vuetify';
import i18n from './plugins/vue-i18n';
import placeholdersPlugin from './plugins/placeholders';
import './plugins/vue-gtag';
import './plugins/vue-hotjar';
import './plugins/sentry';
//4. Vue.js styles.
import './styles/theme.scss';
import preventMultipleClicks from './components/Shared/directives/preventMultipleClicks';

Vue.config.productionTip = false;

Vue.use(placeholdersPlugin);

Vue.prototype.$http = axios;

Vue.directive('prevent-multiple-clicks', preventMultipleClicks);

new Vue({
  el: '#app',
  i18n,
  vuetify,
  router,
  store,
  render: (h) => h(App),
});
